// @ts-expect-error Angular 21 doesn't like imports past the base package
import { StartMeetingResponse } from '@vendasta/meetings/lib';
import { MeetingInfo } from '../meeting-services/interfaces/service-interfaces';

export function constructMeetingInfo(data: StartMeetingResponse): MeetingInfo {
  return <MeetingInfo>{
    startMeetingURL: data.url,
    joinURL: data.joinURL,
    meetingPassword: data.password,
    hasError: false,
  };
}
